export const isPresentKioskParam = (value) => (
  ['1', 'true', 'yes'].includes(String(value || '').toLowerCase())
);

export const getTempLinkIdParam = (search) => {
  const params = new URLSearchParams(search);
  return (
    params.get('temp_links_id')
    || params.get('temp_link_id')
    || params.get('link')
    || params.get('guestLink')
    || ''
  );
};

export const getMyEventsUrlParams = (search) => {
  const params = new URLSearchParams(search);
  const command = (params.get('command') || '').toLowerCase();
  const tempLinkId = getTempLinkIdParam(search);

  return {
    presentKiosk: (
      isPresentKioskParam(params.get('present') || params.get('presentOnly'))
      || command === 'present'
    ),
    tempLinkId,
    guestLink: tempLinkId,
  };
};

export const extractGuestLinkFromReturnPath = (returnPath) => {
  if (!returnPath || !returnPath.includes('?')) return '';
  const query = returnPath.slice(returnPath.indexOf('?') + 1);
  return getTempLinkIdParam(query);
};

export const sanitizeReturnPath = (returnPath) => {
  if (!returnPath || returnPath === '/') return returnPath;
  const [pathname, rawSearch = ''] = returnPath.split('?');
  const params = new URLSearchParams(rawSearch);
  params.delete('temp_links_id');
  params.delete('temp_link_id');
  params.delete('guestLink');
  params.delete('link');
  const qs = params.toString();
  return qs ? `${pathname}?${qs}` : pathname;
};

export const buildGuestPresentPath = (tempLinkId) => (
  `/my-events?command=present&temp_links_id=${encodeURIComponent(tempLinkId)}`
);
